import React from 'react';
import QuestionTreeNode from '../QuestionTreeNode';
import QuestionTreeNodeSubmitOnce from '../QuestionTreeNode/QuestionTreeNodeSubmitOnce';

export default function ExpandedTocItems({ props }: any) {
  const {
    activeQuestionId,
    section,
    navigateToQuestion,
    isExpanded,
    shouldSubmitAllQuestions,
    isAttemptSubmitted,
    isCourseOnOnePage
  } = props;

  const navigateWithKeyEvent = (event: any, { id }: any, question: any) => {
    if (event.key === 'Enter') {
      return navigateToQuestion(id, question.id, isCourseOnOnePage);
    }
    return false;
  };

  const getTabindex = () => (isExpanded ? 0 : -1);

  return props.section.questions.map((question: any, questionIndex: any) =>
    shouldSubmitAllQuestions ? (
      <QuestionTreeNodeSubmitOnce
        role="menuitem"
        key={questionIndex}
        question={question}
        isActive={question.id === activeQuestionId}
        tabIndex={getTabindex()}
        isAttemptSubmitted={isAttemptSubmitted}
        {...(question.id !== activeQuestionId && {
          onClick: () => navigateToQuestion(section.id, question.id, isCourseOnOnePage),
          onKeyDown: event => navigateWithKeyEvent(event, section, question)
        })}
      />
    ) : (
      <QuestionTreeNode
        role="menuitem"
        key={questionIndex}
        question={question}
        isActive={question.id === activeQuestionId}
        tabIndex={getTabindex()}
        {...(question.id !== activeQuestionId && {
          onClick: () => navigateToQuestion(section.id, question.id, isCourseOnOnePage),
          onKeyDown: event => navigateWithKeyEvent(event, section, question)
        })}
      />
    )
  );
}
